<template>
  <div v-if="result?.length" class="search-suggests">
    <p
      v-for="item in props.result"
      :key="item"
      class="search-suggest-item"
      @click="selectSuggest(item)"
      v-html="item"
    />
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['selectSuggest']);

const props = defineProps<{ result?: Array<string> }>();

const selectSuggest = (suggestHTML: string) => {
  if (suggestHTML) {
    const suggest = suggestHTML.replace(/<\/?\w+>/g, '');

    emit('selectSuggest', suggest);
  }
};
</script>

<style lang="scss" scoped>
.search-suggests {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 12px;
  margin-bottom: 15px;
}
.search-suggest-item {
  cursor: pointer;
  color: var(--color-main);
  :deep(b) {
    color: var(--color-dark-grey);
  }
}
</style>
